import { useState, useEffect } from 'react'
import { getPartners, Partner } from '@/services/content'
import useLanguageStore from '@/stores/languageStore'
import { ScrollReveal } from '@/components/ui/scroll-reveal'

export const PartnersSection = () => {
  const { currentLocale } = useLanguageStore()
  const [partners, setPartners] = useState<Partner[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPartners = async () => {
      setLoading(true)
      const { data } = await getPartners()
      if (data) setPartners(data)
      setLoading(false)
    }
    fetchPartners()
  }, [])

  if (!loading && partners.length === 0) return null

  return (
    <section className="py-16 bg-white border-b border-slate-100">
      <div className="container px-4 md:px-6 text-center">
        <ScrollReveal>
          <p className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-8">
            {currentLocale === 'pt'
              ? 'Empresas que confiam em nós'
              : 'Trusted by leading companies'}
          </p>
        </ScrollReveal>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center justify-center opacity-50">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="h-12 w-full bg-slate-100 rounded animate-pulse"
              />
            ))}
          </div>
        ) : (
          <ScrollReveal delay={200}>
            <div className="flex flex-wrap justify-center gap-8 md:gap-16 items-center">
              {partners.map((partner) => (
                <div
                  key={partner.id}
                  className="w-32 md:w-40 h-20 flex items-center justify-center relative group transition-all duration-300"
                >
                  {partner.website_url ? (
                    <a
                      href={partner.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full h-full flex items-center justify-center"
                      title={partner.name}
                    >
                      <img
                        src={partner.logo_url}
                        alt={partner.name}
                        className="max-w-full max-h-full object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                        loading="lazy"
                      />
                    </a>
                  ) : (
                    <img
                      src={partner.logo_url}
                      alt={partner.name}
                      className="max-w-full max-h-full object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                      loading="lazy"
                    />
                  )}
                </div>
              ))}
            </div>
          </ScrollReveal>
        )}
      </div>
    </section>
  )
}
